import { render, staticRenderFns } from "./BetSlipRanking.vue?vue&type=template&id=4d492222&"
import script from "./BetSlipRanking.vue?vue&type=script&lang=js&"
export * from "./BetSlipRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports